<div class="container">
  <div class="row">
    <section class="col-md-7">
      <app-risk-flow-risk-result
      [config]="{
        consumerId: 'GC',
        flow: 'CWP',
        clientType: 'CLIENT'
      }"
      (riskPreferenceHandler)="riskAttitudeChanged($event)"
      (retakingRiskQuizHandler)="retakingRiskQuizHandler()"
      (errorHandler)="errorHandler($event)"
      >
      </app-risk-flow-risk-result>
      <div class="c11n-text-sm disclaimers-wrapper" data-cy="disclaimer">
        <span [innerHTML]="openChoiceCommonContent.disclaimer.part1"></span>
        <span [innerHTML]="openChoiceCommonContent.disclaimer.part2"></span>
        <a c11n-link [variant]="'secondary-reinforced'" [fontWeight]="'normal'" [href]="openChoiceCommonContent.disclaimer.linkHref">{{ openChoiceCommonContent.disclaimer.linkText }}</a>
        <span [innerHTML]="openChoiceCommonContent.disclaimer.part3"></span>
      </div>
      <vgim-secure-link></vgim-secure-link>
    </section>
    <div class="col-md-1"></div>
      <section class="col-md-4">
        <c11n-button id="riskQuizResultsContinueBTN" [labelText]="openChoiceCommonContent.continueButton" [fullWidth]="true"
          (clickEvent)="continue()"></c11n-button>
        <app-cancel [isOpenChoice]="true"></app-cancel>
        <app-feedback-survey></app-feedback-survey>
      </section>
  </div>
</div>
